import axios, { AxiosResponse } from 'axios';

export const getPrintForm = (apiUrl: string, params = {}, isPost = false, tokenStr?: string) => {
    if (isPost) {
        return axios.post(apiUrl, params, {
            params: { print: true, language: params?.['language'] },
            responseType: "arraybuffer",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/pdf",
            },
        });
    }

    return axios.get(apiUrl, {
        params: { ...params, print: true },
        responseType: "arraybuffer",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/pdf",
            'Authorization': `${tokenStr}`
        },
    });
};
